import React, { useState } from 'react';
import { Button } from '~/presentation/components/UI/buttons';
import { Step, StepMagic } from '~/presentation/components/steps';
import { Health } from '~/presentation/base/icons';
import { GetCertificates } from '~/domain/usecases/deamon/remote';
import {
  Container,
  Content,
  Header,
  Body,
  Footer,
} from './styles/StyledAntimicrobial';
import GeneralData from './GeneralData';
import AntiMicroPrescription from './AntiMicroPrescription';
import { Signature } from '../signature';
import AntiMicrobialView from './AntiMicrobialView';

import { translator } from '../i18n';

const AntimicrobialPrescription: React.FC = () => {
  const [crement, setCrement] = useState<number>(1);

  const data = {
    isSigned: 'Assinado',
    name: 'Denilson',
  };

  function handleBar(number: number) {
    if (crement + number > 4 || crement + number < 1) {
      setCrement(crement);
    } else {
      setCrement(crement + number);
    }
  }

  const certificatedSelected = (datatest: GetCertificates.Certificate) => {
    console.log('selected: ', datatest);
  };

  return (
    <Container>
      <Content>
        <Health />
        <h1>Receita antimicrobiano</h1>
      </Content>
      {crement !== 4 ? (
        <Header>
          <StepMagic current={crement}>
            <Step title="Informações gerais" />
            <Step title="Prescrição" />
            <Step title="Assinatura do documento" />
          </StepMagic>
        </Header>
      ) : null}
      <Body>
        {crement === 1 && <GeneralData />}
        {crement === 2 && <AntiMicroPrescription />}
        {crement === 3 && (
          <Signature
            changeSelected={(e: string) =>
              console.log('certificado escolhido: ', e)
            }
          />
        )}
        {crement === 4 && (
          <AntiMicrobialView isSigned={data.isSigned} name={data.name} />
        )}
      </Body>
      {crement !== 4 ? (
        <Footer>
          {crement > 1 ? (
            <Button
              rounded
              variant="secundary"
              onClick={() => handleBar(-1)}
              size="small"
            >
              {translator('Voltar')}
            </Button>
          ) : null}
          <Button rounded size="small" onClick={() => handleBar(1)}>
            {translator('Avançar')}
          </Button>
        </Footer>
      ) : null}
    </Container>
  );
};

export default AntimicrobialPrescription;
